export default __webpack_public_path__ + "static/media/1.9ae70dd2.jpg";